import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Icon from '@material-ui/core/Icon';
import _ from 'lodash';
import { toJS } from '../../utils/helper';

import ItemTypeIcon from '../Common/ItemTypeIcon';

import styles from './styles';
import { fetchItemTypesRoutine, fetchTaskProfilesRoutine } from '../../redux/routines';
import ListItemText from '@material-ui/core/ListItemText';

const SelectableList = List; // TODO makeSelectable(List);

class TaskProfileDrilldown extends React.Component {
  state = {
    taskProfiles: [],
    taskProfile: {},
    selected: 0,
  };

  componentWillMount() {
    this.props.fetchTaskProfiles();
    this.props.fetchItemTypes();
  }

  handleSelectTaskProfile = (evt, taskProfile) => {
    console.log('handleSelectTaskProfile', taskProfile);
    this.setState({
      taskProfile,
    });

    if (!this.props.selectable) {
      this.props.onChange([taskProfile]);
    }
  };

  handleAddTaskProfile = (taskProfile) => {
    // if (!this.props.selectable) {
    //   return this.handleSelectTaskProfile(null, taskProfile);
    // }

    console.log('handleAddTaskProfile', taskProfile);
    let taskProfiles = this.state.taskProfiles || [];
    if (this.props.selectable) {
      if (taskProfiles.indexOf(taskProfile) >= 0) {
        taskProfiles = taskProfiles.filter((tp) => tp.id !== taskProfile.id);
      } else {
        taskProfiles = taskProfiles.concat([taskProfile]);
      }
    } else {
      taskProfiles = [taskProfile];
    }

    this.props.onChange(taskProfiles);

    this.setState({
      taskProfiles,
      taskProfile,
    });

    // this.props.onChange(taskProfiles);
  };

  renderTaskProfileListItem(taskProfile, selected) {
    const iconName = this.props.selectable ? (selected ? 'done' : 'add') : 'list';
    const icon = <Icon style={styles.stageIcon}>{iconName}</Icon>;
    // const iconColor = this.props.selectable && selected ? 'green' : null;

    return (<ListItem
      key={taskProfile.id}
      value={taskProfile}
    >
      <Avatar
        icon={icon}
        onClick={() => this.handleAddTaskProfile(taskProfile)}
      />
      <ListItemText primary={taskProfile.name}/>
      <ListItemSecondaryAction>
        <ChevronRightIcon style={styles.stageIcon}/>
      </ListItemSecondaryAction>
    </ListItem>);
  }

  renderTaskProfileItemListItem(itemType, quantity) {
    if (itemType) {
      return (<ListItem
        key={itemType.id}
      >
        <Avatar
          icon={<ItemTypeIcon type={itemType} height={26}/>}/>
        <ListItemText primary={itemType.name} secondary={`Quantity: ${quantity}`}/>
      </ListItem>);
    } else {
      return null;
    }
  }

  renderTaskProfileItems(itemTypes = {}) {
    return (<div style={styles.taskProfileItems}>
      <Typography>Items</Typography>
      <List style={styles.itemsList}>
        {_.keys(itemTypes).map((id) => {
          return this.renderTaskProfileItemListItem(this.props.itemTypes[id], itemTypes[id]);
        })}
      </List>
    </div>);
  }

  render() {
    const selected = this.state.taskProfiles || [];
    const available = _.differenceBy(this.props.allTaskProfiles, selected, 'id');

    return (<div style={styles.container}>
      <div style={styles.taskProfiles}>
        <Typography>Task Profiles</Typography>
        <SelectableList
          value={this.state.taskProfile}
          onChange={this.handleSelectTaskProfile}>
          {selected.map((taskProfile) => this.renderTaskProfileListItem(taskProfile, true))}
          {available.map((taskProfile) => this.renderTaskProfileListItem(taskProfile, false))}
        </SelectableList>
      </div>
      {this.renderTaskProfileItems(this.state.taskProfile.itemTypes)}
    </div>);
  }
}

TaskProfileDrilldown.propTypes = {
  fetchTaskProfiles: PropTypes.func.isRequired,
  // taskProfiles: PropTypes.array.isRequired,
  allTaskProfiles: PropTypes.array.isRequired,

  onChange: PropTypes.func.isRequired,
  selectable: PropTypes.bool,

  fetchItemTypes: PropTypes.func.isRequired,
  itemTypes: PropTypes.object.isRequired,
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchTaskProfiles: fetchTaskProfilesRoutine.trigger,
    fetchItemTypes: fetchItemTypesRoutine.trigger,
  }, dispatch);
}

function mapStateToProps(state) {
  return {
    // allTaskProfiles: state.getIn('taskprofiles').get('taskProfiles').toJS(),
    itemTypes: toJS(state.getIn(['itemtypes', 'itemTypes'])),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TaskProfileDrilldown);



// WEBPACK FOOTER //
// ./src/components/TaskProfileDrilldown/index.js